/** Search term parameter used for the URL */
export const SEARCH_BETTING_TERM_PARAMETER = 'term';
